




































import { Component, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { SearchProductOptions, SearchProductOptionsMultiples, SearchResult } from '@/models'
import { MutationTypes } from '@/store/mutation-types'

@Component({
  components: {
    UpsertProductModal: () => import('@/components/modals/UpsertProductModal.vue'),
    ProductListFilters: () => import('@/components/ProductListFilters.vue'),
    ProductTracingCard: () => import('@/components/tracing/ProductTracingCard.vue')
  }
})
export default class Tracing extends Vue {
  private defaultPageSize = 10

  private searchResult: SearchResult = {
    items: [],
    totalResults: 0,
    pageSize: this.defaultPageSize,
    pageOffset: 1
  }

  private filters: SearchProductOptionsMultiples = {
    educationLevel1: [],
    manager: [],
    type: [],
    search: '',
    country: [],
    editorialProject: [],
    workType: [],
    subject: [],
    offset: 0,
    limit: 0,
    relatedToDigital: null,
    editorialProjectYearStart: [],
    productionCampaign: [],
    language: [],
    educationLevel2: []
  }

  private currentPage = this.$router.currentRoute.query.currentPage ? parseInt(this.$router.currentRoute.query.currentPage.toString()) : 1

  @Watch('currentPage')
  onCurrentPageChanged() {
    this.search()
  }

  get disableActions(): boolean {
    return !this.$store.getters.isAdmin
  }

  get isAdmin(): boolean {
    return this.$store.getters.isAdmin
  }

  private search() {
    this.$store.commit(MutationTypes.SET_LOADING, true)
    let subject = null
    if (this.filters.subject && this.filters.subject?.length > 0) {
      subject = this.filters.subject.map((item) => item.split('-')[1]).join(',')
    }
    let language = null
    if (this.filters.language && this.filters.language?.length > 0) {
      language = this.filters.language.map((item) => item.split('-')[1]).join(',')
    }
    let educationLevel2 = null
    if (this.filters.educationLevel2 && this.filters.educationLevel2?.length > 0) {
      educationLevel2 = this.filters.educationLevel2.map((item) => item.split('-')[1]).join(',')
    }
    const searchOptions: SearchProductOptions = {
      search: this.filters.search,
      offset: (this.currentPage - 1) * this.defaultPageSize,
      limit: this.defaultPageSize,
      educationLevel1: (this.filters.educationLevel1 && this.filters.educationLevel1?.length > 0) ? this.filters.educationLevel1.join(',') : null,
      manager: (this.filters.manager && this.filters.manager?.length > 0) ? this.filters.manager.join(',') : null,
      type: (this.filters.type && this.filters.type?.length > 0) ? this.filters.type.join(',') : null,
      country: (this.filters.country && this.filters.country?.length > 0) ? this.filters.country.join(',') : null,
      subject: subject,
      editorialProject: (this.filters.editorialProject && this.filters.editorialProject?.length > 0) ? this.filters.editorialProject.join(',') : null,
      workType: (this.filters.workType && this.filters.workType?.length > 0) ? this.filters.workType.join(',') : null,
      relatedToDigital: null,
      showMilestone: true,
      editorialProjectYearStart: null,
      productionCampaign: (this.filters.productionCampaign && this.filters.productionCampaign?.length > 0) ? this.filters.productionCampaign.join(',') : null,
      language: language,
      educationLevel2: educationLevel2
    }

    ApiClient.searchProducts(searchOptions)
      .then(async(result) => {
        this.searchResult = result
        if (result.totalResults < result.pageOffset) {
          this.currentPage = 1
          this.search()
        }
      })
      .catch((e) => {
        console.error(e)
      }).finally(() => {
        this.$store.commit(MutationTypes.SET_LOADING, false)
      })
  }

  private resetSearch() {
    this.filters.educationLevel1 = []
    this.filters.manager = []
    this.filters.type = []
    this.filters.country = []
    this.filters.editorialProject = []
    this.filters.workType = []
    this.filters.subject = []
    this.filters.search = ''
    this.currentPage = 1
    this.search()
  }
}
